import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Icons from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Stamp } from "./shared";

export default function CopyLink() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [url, setUrl] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/dms/link/${token}`).then(async ({ data }) => {
      setInfo(data);
      const res = await api.get(`/dms/files/${data.file_id}?token=${token}`, { responseType: "blob" });
      setUrl(URL.createObjectURL(res.data));
    }).catch((e) => setErr(e.response?.data?.detail || "This link is not available"));
  }, [token]);
  return (
    <div className="uemp-fade-in">
      <PageHeader title="Document Copy" subtitle="View-only copy issued to you by the Document Control Officer" />
      {err && <div className="rounded-xl border border-rose-200 bg-rose-50 p-6 text-sm text-rose-700 flex items-center gap-2" data-testid="copy-link-error"><Icons.ShieldAlert className="h-5 w-5" />{err}</div>}
      {info && (
        <div className="space-y-3" data-testid="copy-link-view">
          <div className="flex flex-wrap items-center gap-2 text-sm"><span className="font-mono text-slate-400">{info.no}</span><span className="font-semibold text-slate-900">{info.title}</span><Stamp s={info.stamp} /><span className="ml-auto text-xs text-slate-500">Expires {new Date(info.expires_at).toLocaleString()}</span></div>
          <div className="rounded-xl border border-slate-200 bg-white overflow-hidden h-[75vh]" onContextMenu={(e) => e.preventDefault()}>{url ? <iframe title="document" src={`${url}#toolbar=0`} className="w-full h-full" /> : <div className="h-full animate-pulse bg-slate-50" />}</div>
        </div>
      )}
    </div>
  );
}
